export default "__VITE_ASSET__CgqrZZbJ__"